<template>
  <div
    class="flex flex-row gap-2 text-xs"
    :data-has-period="billingEnd && billingStart ? '1' : '0'"
    data-testid="billing-period-label"
  >
    <span class="font-semibold">Billing period:</span>
    <span class="flex flex-row gap-2" v-if="billingEnd && billingStart">
      <BillingPeriodValue
        :billingEnd="billingEnd"
        :billingStart="billingStart"
      />
      <Info>
        <template #content
          >Usage is calculated based on events between {{ billingStart }} and
          {{ billingEnd }} UTC time.</template
        >
      </Info>
      <TimeRemaining :date="billingEnd" />
    </span>
    <span v-else>moving monthly window.</span>
  </div>
</template>
<script setup lang="ts">
import { useStore3 } from '~/store/main';
import Info from '../form/Info.vue';
import BillingPeriodValue from './BillingPeriodValue.vue';
import TimeRemaining from './TimeRemaining.vue';

const store3 = useStore3();
const { account } = storeToRefs(store3);
const billingStart = computed(
  () => account.value?.currentPeriod.currentPeriodStart,
);
const billingEnd = computed(
  () => account.value?.currentPeriod.currentPeriodEnd,
);
</script>
